<template>
  <div class="ordersMGT-details app-container">
    <div class="global-header-wrap">
      <h3>
        {{ $t("sale.orders.title") }}：<span>{{
          currentDetails.order_id
        }}</span>
      </h3>
      <button class="global-button-style" @click="$router.push({ name: 'vn' })">
        {{ $t("commonMsg.back") }}
      </button>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="ordersMGT-details-header">
        <div class="ordersMGT-details-header-left">
          <p class="omitText" :title="currentDetails.order_id">
            <span>{{ $t("sale.orders.title") }}：</span
            >{{ currentDetails.order_id }}
          </p>
          <p class="omitText" :title="currentDetails.created_at | filterDate">
            <span>{{ $t("commonMsg.createdAt") }}：</span
            >{{ currentDetails.created_at | filterDate }}
          </p>
          <p class="omitText" :title="currentDetails.fee_type | filterFeeTypes">
            <span>{{ $t("sale.orders.fee_type") }}：</span
            >{{ currentDetails.fee_type | filterFeeTypes }}
          </p>
          <p class="omitText" :title="currentDetails.user.nickname">
            <span>{{ $t("user.username") }}：</span
            >{{ currentDetails.user.nickname }}
          </p>
          <p class="omitText" :title="currentDetails.pay_time">
            <span>{{ $t("sale.orders.pay_time") }}：</span
            >{{ currentDetails.pay_time || "-" }}
          </p>
          <p class="omitText" :title="currentDetails.out_trade_no">
            <span>{{ $t("sale.orders.out_trade_no") }}：</span
            >{{ currentDetails.out_trade_no }}
          </p>
        </div>
        <div class="ordersMGT-details-header-right">
          <p>{{ $t("content.books.price") }}：{{ currentDetails.total }}</p>
        </div>
      </div>
      <div class="global-body-wrap">
        <TableView :tableData="tableData" :tableProp="tableProp" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableView from "@/components/tableView";
export default {
  components: {
    TableView,
  },
  computed: {
    ...mapGetters(["appendPopup"]),
    tableProp() {
      let tableProp = [
        {
          prop: "name",
          label: this.$t("content.books.bookName"),
        },
        {
          prop: "price",
          label: this.$t("content.books.price"),
        },
      ];
      return tableProp;
    },
  },
  data() {
    return {
      currentDetails: { user: {} },
      tableData: [],
      total: 0,
    };
  },

  methods: {
    async getList() {
      let res = await this.$http.getOrdersDetails(this.$route.query.i);
      this.currentDetails = res.data;
      this.tableData = res.data.books;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.ordersMGT-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ordersMGT-details-header-left {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    > p {
      width: 31%;
      line-height: 40px;
      > span {
        font-weight: 800;
      }
    }
  }
  .ordersMGT-details-header-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border: 1px solid #ccc;
    border-radius: 100px;
    margin-left: 20px;
  }
}
</style>
